import styled from "@emotion/styled";

import { fontMerriweather, fontRoboto, theme } from "shared/lib/styles";

export const Container = styled.div`
  position: relative;

  inline-size: 280px;
  max-block-size: 476px;
  margin: auto;

  background-color: #001246;

  outline: none;

  ${theme.breakpoints.up("mobile")} {
    inline-size: calc(100vw - 40px);
    max-block-size: 670px;
  }

  ${theme.breakpoints.up("tablet")} {
    inline-size: 600px;
    max-block-size: 729px;
  }
`;

export const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  inline-size: 100%;
  block-size: 100%;
  max-block-size: 187px;

  overflow: hidden;

  ${theme.breakpoints.up("mobile")} {
    block-size: 224px;
    max-block-size: 224px;
  }

  ${theme.breakpoints.up("tablet")} {
    inline-size: 600px;
    block-size: 400px;
    max-inline-size: 600px;
    max-block-size: 400px;
  }

  img {
    display: block;

    inline-size: 100%;
    block-size: 100%;

    object-fit: cover;
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;

  inline-size: 100%;
  block-size: 289px;
  padding-block: 16px;
  padding-inline: 20px;

  ${theme.breakpoints.up("tablet")} {
    block-size: 250px;
    max-inline-size: 600px;
    padding: 40px;
  }
`;

export const Title = styled.div`
  margin-block-end: 12px;

  color: #ffca05;
  font-size: 20px;
  font-family: ${fontMerriweather};
  line-height: 25px;
  text-align: center;
`;

export const Description = styled.div`
  margin-block-end: 12px;

  color: #ffffff;
  font-size: 15px;
  font-family: ${fontRoboto};
  line-height: 19px;
  text-align: center;

  span {
    font-weight: 700;
  }
`;
